import React, { useEffect, useState } from 'react';
import Colors from '../../constants/Colorsv2';
import QRCode from 'qrcode.react';
//Import Redux Store and Actions
import { useDispatch, useSelector } from 'react-redux';
import * as Clipboard from 'expo-clipboard';
import { View, TouchableOpacity, ScrollView, FlatList, ActivityIndicator, Image, TextInput } from 'react-native';
import { Icon } from 'react-native-elements';
import { Text } from '../../globalComponents/NativeOverrides';

import { player_getActivePromos, player_getReferralByPlayerId, player_getRequestDetailsByPlayerIdAndStatus, player_getRequestStatsByPlayerId, player_updatePlayerReferral } from '../../store/actionsv1/player';
import { CodeRequestProps, CodeRequestStats2Props, PlayerReferralProps, PromoProps, PublicPlayerProps } from '../../store/types/auth_svc';
import PlayerCard from '../Social/components/PlayerCard';
import moment from 'moment';
import { BELinkApi } from 'be-components';
import { util_updateShare } from '../../store/actionsv1/utils';


function InviteFriendsScreen ({ navigation }: any) {
    const [ offset, setOffset ] = useState(0);
    const [ requests_loading, setRequestsLoading ] = useState(false);
    const [ active_tab, setActiveTab ] = useState('requested');
    const [ loading, setLoading ] = useState(false);
    const [ update_loading, setUpdateLoading ] = useState(false);
    const [ help_visible, setHelpVisible ] = useState(false);
    const [ promo_expanded, setPromoExpanded ] = useState(false);
    const [ expanded, setExpanded ] = useState(true);
    const [ draft_referral, setDraftReferral ] = useState<PlayerReferralProps>();
    const [ copied, setCopied ] = useState(false);
    const [ promos, setPromos ] = useState<PromoProps[]>([])
    


    const dispatch = useDispatch();

    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.updated == right.updated);
    const promo: PromoProps | undefined = useSelector((state:any) => state.player.promo, (left, right) => left?.promo_id == right?.promo_id)
    const player_referral:PlayerReferralProps | undefined = useSelector((state:any) => state.player.player_referral, (left, right) => left?.last_update_datetime == right?.last_update_datetime)
    const code_request_stats:CodeRequestStats2Props | undefined = useSelector((state:any) => state.player.code_request_stats, (left, right) => left?.pending == right?.pending)
    const code_requests_list:{ updated:number, code_requests:CodeRequestProps[] } = useSelector((state:any) => state.player.code_requests_list, (left, right) => left.updated == right.updated)
    const { code_requests } = code_requests_list;
    const stored_players:PublicPlayerProps[] = useSelector((state:any) => state.social.stored_players, (left, right) => left.length == right.length);

    useEffect(() => {
        if(!player){ return }
        getPlayerReferralFromServer(player.player_id)
    },[player?.player_id])

    useEffect(() => {
        setDraftReferral(player_referral)
    },[player_referral])


    const getPlayerReferralFromServer = async(player_id:string) => {
        setLoading(true)
        await dispatch(player_getReferralByPlayerId(player_id))
        await dispatch(player_getRequestStatsByPlayerId(player_id))
        const ps = await player_getActivePromos()
        setPromos(ps)
        setLoading(false)
    }

    useEffect(() => {
        getRequestDetailsFromServer(active_tab, 0)
    },[active_tab])

    const getRequestDetailsFromServer = async(status:string, offset:number) => {
        if(!player || requests_loading){ return }
        setRequestsLoading(true);
        await dispatch(player_getRequestDetailsByPlayerIdAndStatus(player.player_id, status, offset))
        setOffset(offset+1)
        setRequestsLoading(false)
    }

    const handleSaveCode = async() => {
        if(!draft_referral || update_loading){ return } //Dont do anything!
        setUpdateLoading(true);
        await dispatch(player_updatePlayerReferral(draft_referral))
        setUpdateLoading(false)
    }


    const getAmount = () => {
        if(!draft_referral){ return '' }
        let selected_promo = promos.find(p => p.promo_id == draft_referral.promo_id)
        if(!selected_promo){ return '' }
        let amount = ''
        switch(selected_promo.type){
            case 'referral_code':
                amount = ` $${selected_promo.amount} `
                break
            case 'referral_sweepstakes':
                amount = ` up to $500 `
                break
            case 'promo_code':
                amount = ` $${selected_promo.amount} `
                break
            case 'promo_sweepstakes':
                amount = ` up to $500 `
                break
            default:
                amount =  ` $$ `
                break
        }
        return amount
    }

    const shareCode = async() => {
        if(!player_referral || !promo || !player){ return }

        dispatch(util_updateShare({
            share_key: `invite_${player.player_id}_share`,
            visible:true,
            title: `Checkout BettorEdge - Betting Marketplace`,
            body: `Join BettorEdge and receive${getAmount()}once you verify your account. Use Code: ${player_referral.referral_code}`,
            type_id: player.player_id,
            generator:'player',
            link_type: 'user_generated_link',
            link_sub_type: 'user_referral_link',
            redirect_url: `https://app.bettoredge.com/account/authenticate?refer=${player_referral.referral_code}`,
        }))
    }


    const refer_steps = [
        { step: 1, description: `Friend uses your code when they sign up` },
        { step: 2, description: `Your friend receives${getAmount()}when they verify` },
        { step: 3, description: `You receive${getAmount()}when they deposit` }
    ]


    const renderCodeRequests = (data: { item:CodeRequestProps, index:number }) => {
        const referred_user = stored_players.find(p => p.player_id == data.item.player_id)
        if(!referred_user){ return <></> }
        return (
            <View style={{ margin:5, borderRadius:4 }}>
                <PlayerCard viewer_id={player?.player_id??'0'} player={referred_user} onPlayerPress={(p) => navigation.navigate('SocialStack', { screen: 'SocialProfile', initial:false, params: { player_id: p.player_id } })}/>
            </View>
        )
    }

    const renderSteps = (data: {item:{ step:number, description:string }, index:number}) => {
        return (
            <View style={{ margin:5, borderRadius:4, backgroundColor:Colors.shades.shade100, padding:10, width: (app_size.width - 60) / 3 }}>
                <Text size={16} color={Colors.brand.midnight} weight='bold'>Step {data.item.step}</Text>
                <Text style={{ marginTop:10 }} size={12} color={Colors.brand.midnight} weight='regular'>{data.item.description}</Text>
            </View>
        )
    }

    const renderPromos = (data: { item:PromoProps, index:number }) => {
        if(!draft_referral){ return <></> }
        return (
            <TouchableOpacity 
                style={{ padding:10, borderBottomWidth:1, borderColor:Colors.shades.shade600 }}
                onPress={() => {
                    if(player?.type != 'premium'){ return alert('Update to premium to update your referral code!') }
                    setDraftReferral({ ...draft_referral, promo_id: data.item.promo_id })
                    setPromoExpanded(false);
                }}>
                <Text size={14} color={Colors.brand.midnight} weight='regular'>{data.item.description}</Text>
            </TouchableOpacity>
        )
    }

    const handleUpdateCode = (code:string) => {
        if(!draft_referral){ return }
        if(player?.type != 'premium'){ return alert('Upgrade to premium to update your referral code!') }
        setDraftReferral({
            ...draft_referral,
            referral_code: code
        })
    }

   
    if(!player_referral || !draft_referral || !promo || !player){
        return (
            <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }

    const selected_promo = promos.find(p => p.promo_id == draft_referral.promo_id);
    let available_promos = promos.filter(p => p.type == 'referral_code' && p.amount == 20)
    available_promos = promos.filter(p => p.type == 'referral_sweepstakes').concat(available_promos)
    available_promos = available_promos.filter(p => p.promo_id != draft_referral.promo_id)
    
    const is_dirty = JSON.stringify(draft_referral) == JSON.stringify(player_referral) ? false : true

    return (
        <View style={{flex:1}}>
            <View style={{ padding:20, backgroundColor:Colors.shades.shade100 }}>
                <Text size={18} color={Colors.brand.midnight} weight='bold'>My Referral Dashboard</Text>
                <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='regular'>Below you can find you referral code and the progress of users that you have referred.</Text>
            </View>
            <ScrollView style={{ flex:1, backgroundColor:Colors.shades.white }}>
                <View style={{ backgroundColor:Colors.highlights.highlight400Faded, padding:20 }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between'}} onPress={() => setHelpVisible(!help_visible)}>
                        <Text size={18} color={Colors.brand.midnight} weight='bold'>How does it work?</Text>
                        <Icon name={help_visible?'chevron-up':'chevron-down'} type='feather' size={16} color={Colors.brand.midnight}/>
                    </TouchableOpacity>                    
                    {help_visible ?
                    <View style={{ marginTop:10 }}>
                        <FlatList
                            data={refer_steps}
                            renderItem={renderSteps}
                            horizontal
                            showsHorizontalScrollIndicator={false}
                        />
                    </View>
                    :<></>}
                </View>
                <View style={{ backgroundColor:Colors.shades.shade100, padding:20 }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between'}} onPress={() => setExpanded(!expanded)}>
                        <Text size={18} color={Colors.brand.midnight} weight='bold'>My Referral Code</Text>
                        <Icon name={expanded?'chevron-up':'chevron-down'} type='feather' size={16} color={Colors.brand.midnight}/>
                    </TouchableOpacity>
                    {expanded ?
                    <View style={{ marginTop:10 }}>

                    <View style={{ flexDirection:'row' }}>
                        <View style={{ padding:10 }}>
                            <QRCode 
                            fgColor={Colors.brand.cyan}
                            size={120}
                            value={`https://app.bettoredge.com/account/authenticate?refer=${player_referral.referral_code}&utm_source=qrcode`}
                            level={"L"}
                            includeMargin={false}
                            renderAs={"svg"}
                            />
                        </View>
                        <View style={{ flex:1, padding:10 }}>
                            <View nativeID='referral_code'>
                                <Text style={{ marginBottom:3 }} size={14} color={Colors.brand.midnight} weight='regular'>CODE:</Text>
                                <TextInput
                                    style={{ borderRadius:4, padding:10, borderWidth:1, textAlign:'center', backgroundColor:Colors.shades.white, borderColor:Colors.shades.shade600, fontSize:14, color:Colors.brand.midnight, fontFamily: 'barlow-bold' }}
                                    onChangeText={(text) => handleUpdateCode(text)}
                                    placeholderTextColor={Colors.shades.shade600}
                                    value={draft_referral.referral_code}
                                />
                            </View>
                            {selected_promo ?
                            <View style={{ marginTop:5 }}>
                                <Text style={{ marginBottom:3 }} size={14} color={Colors.brand.midnight} weight='regular'>PROMOTION:</Text>
                                <View nativeID='promo_options' style={{ backgroundColor:Colors.shades.white, borderRadius: 4, borderWidth:1, borderColor:Colors.shades.shade600 }}>
                                    <TouchableOpacity style={{ marginTop:5, padding:10, flexDirection:'row', alignItems:'center' }} onPress={() => setPromoExpanded(!promo_expanded)}>
                                        <Text style={{ flex:1 }} size={14} color={Colors.brand.midnight} weight='bold'>{selected_promo.description}</Text>
                                        <Icon name={promo_expanded?'chevron-up':'chevron-down'} type='feather' size={14} color={Colors.brand.midnight} />
                                    </TouchableOpacity>
                                    {promo_expanded ?
                                    <View nativeID='promo_options' style={{ borderWidth:1, borderColor:Colors.shades.shade600 }}>
                                        <FlatList
                                            data={available_promos}
                                            renderItem={renderPromos}
                                            keyExtractor={(item) => item.promo_id.toString()}
                                        />
                                    </View>
                                    :<></>}
                                </View>
                            </View>
                            :<></>}
                        </View>
                            
                        </View>
                        <View nativeID='action_row' style={{ flexDirection:'row', marginTop:15 }}>
                            <TouchableOpacity style={{ flex:1, ...styles.buttonStyle }} onPress={() => shareCode()}>
                                <Icon containerStyle={{ marginRight:5 }} name='share' type='feather' color={Colors.brand.cyan} size={20} />
                                <Text size={16} weight='bold' color={Colors.brand.midnight}>Share Link</Text>
                            </TouchableOpacity>
                           {is_dirty ?
                           <TouchableOpacity style={{ flex:1, ...styles.buttonStyle, backgroundColor:Colors.utility.success, marginLeft:5 }} onPress={() => handleSaveCode()}>
                                <Text size={16} weight='bold' color={Colors.shades.white}>UPDATE</Text>
                            </TouchableOpacity>
                           :<></>}
                        </View>
                        {player?.type != 'premium' ?
                        <View style={{ marginTop:25, padding:10, backgroundColor:Colors.shades.shade600, borderRadius:8 }}>
                            <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>Want to customize your referral code and promotion?</Text>
                            <TouchableOpacity style={{ marginTop:10, padding:10, borderRadius:8, backgroundColor:Colors.incentive.gold }}
                            onPress={() => navigation.navigate('AuthStack', { screen: 'Premium' })}>
                                <Text size={14} color={Colors.shades.white} weight='semibold' textAlign='center'>View Premium</Text>
                            </TouchableOpacity>
                        </View>
                        :<></>}
                        {player.vouched_status !== 'verified' ?
                            <TouchableOpacity onPress={() => navigation.navigate('Vouch')}>
                                <Text size={14} weight='regular' color={Colors.brand.electric} style={{marginTop:16}} textAlign='center'>Your account must be verified before you can earn!</Text>
                            </TouchableOpacity>
                            :<></>}
                    </View>
                    :<></>}
                </View>
                <View style={{flexDirection:'row', alignItems:'center', marginTop:20, paddingLeft:20, paddingRight:20, height:48, backgroundColor:Colors.shades.white}}>
                    <TouchableOpacity style={{ flex:1, paddingTop:14, paddingBottom:14, paddingRight:6, paddingLeft:6, borderColor:Colors.brand.midnight, borderBottomWidth:active_tab==='requested'? 1 : 0 }} onPress={() => setActiveTab('requested')}>
                        <Text size={14} weight={active_tab === 'requested' ? 'bold' : 'regular'} color={active_tab === 'requested' ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>Unverified</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={{ flex:1, paddingTop:14, paddingBottom:14, paddingRight:6, paddingLeft:6, borderColor:Colors.brand.midnight, borderBottomWidth:active_tab==='fulfilled'? 1 : 0 }} onPress={() => setActiveTab('fulfilled')}>
                        <Text size={14} weight={active_tab === 'fulfilled' ? 'bold' : 'regular'} color={active_tab === 'fulfilled' ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>Pending Deposit</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={{ flex:1, paddingTop:14, paddingBottom:14, paddingRight:6, paddingLeft:6, borderColor:Colors.brand.midnight, borderBottomWidth:active_tab==='closed'? 1 : 0 }} onPress={() => setActiveTab('closed')}>
                        <Text size={14} weight={active_tab === 'closed' ? 'bold' : 'regular'} color={active_tab === 'closed' ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>Converted</Text>
                    </TouchableOpacity>
                </View>
                <View style={{ marginTop:10, padding:10 }}>
                    <FlatList data={code_requests.sort((a,b) => moment(b.create_datetime).unix() - moment(a.create_datetime).unix())} renderItem={renderCodeRequests} keyExtractor={(item) => item.code_request_id.toString()}/>
                    {code_requests.length > 9 ?
                    <TouchableOpacity style={{ marginTop:10, borderWidth:1, borderColor:Colors.brand.midnight, borderRadius:4, padding:10 }} onPress={() => getRequestDetailsFromServer(active_tab, offset)}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>Load More</Text>
                    </TouchableOpacity>
                    :<></>}
                    {code_requests.length == 0 && ! requests_loading ?
                    <View style={{justifyContent:'center', alignItems:'center', padding:20}}>
                        <Image
                            source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698862064/open_box_nryphw.png' }}
                            style={{ width: 200, height: 200 }}
                            resizeMode='contain'
                        />
                        <Text style={{ marginTop:10 }} size={14} color={Colors.brand.midnight} textAlign='center'>No Requests</Text>
                    </View>
                    :<></>}
                    {requests_loading ?
                    <ActivityIndicator style={{ padding:20, alignSelf: 'center' }} size='large' color={Colors.brand.midnight} />
                    :<></>}
                </View>
            </ScrollView>
            {code_request_stats ?
            <View style={{ flexDirection:'row', alignItems:'center', padding:5, backgroundColor:Colors.brand.midnight }}>
                <View style={{ flex:1, padding:10, justifyContent:'center', alignItems:'center' }}>
                    <Text size={14} color={Colors.shades.white} textAlign='center' weight='regular'>Pending</Text>
                    <Text style={{ marginTop:5 }} size={18} color={Colors.shades.white} textAlign='center' weight='bold'>{code_request_stats.pending}</Text>
                </View>
                <View style={{ flex:1, padding:10, justifyContent:'center', alignItems:'center' }}>
                    <Text size={14} color={Colors.shades.white} textAlign='center' weight='regular'>Converted</Text>
                    <Text style={{ marginTop:5 }} size={18} color={Colors.shades.white} textAlign='center' weight='bold'>{code_request_stats.closed}</Text>
                </View>
            </View>
            :<></>}
        </View>
    )

}

const styles = {
    buttonStyle : { flexDirection:'row', justifyContent:'center', alignItems:'center', backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.2)", 
    shadowOffset: { width: 0, height: 0 }, shadowRadius: 8, shadowOpacity: 1, borderRadius: 20, padding:10 },
    toggleStyle : { flexDirection : 'row', alignItems:'center', backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.06)", 
    shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1, paddingRight:16, paddingLeft:16 }
}

export default InviteFriendsScreen

